(function () {
  function lockBody(locked) {
    document.documentElement.classList.toggle('dodo-cart-drawer-open', locked);
    document.body.classList.toggle('dodo-cart-drawer-open', locked);
  }

  function getRoot() {
    return document.querySelector('[data-dodo-header]');
  }

  function getSectionId(root) {
    return root ? root.getAttribute('data-dodo-section-id') : '';
  }

  function getDrawerParts(root) {
    if (!root) {
      return {};
    }

    return {
      root: root,
      drawer: root.querySelector('[data-dodo-cart-drawer]'),
      toggle: root.querySelector('[data-dodo-cart-toggle]'),
      panel: root.querySelector('.dodo-cart-drawer__panel')
    };
  }

  function setOpenState(root, shouldOpen, instant) {
    var parts = getDrawerParts(root);
    if (!parts.drawer || !parts.toggle) {
      return;
    }

    if (shouldOpen) {
      parts.drawer.hidden = false;
      parts.toggle.setAttribute('aria-expanded', 'true');
      if (instant) {
        parts.drawer.classList.add('is-open');
        lockBody(true);
        return;
      }
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          parts.drawer.classList.add('is-open');
          lockBody(true);
          if (parts.panel) {
            parts.panel.focus();
          }
        });
      });
      return;
    }

    parts.drawer.classList.remove('is-open');
    parts.toggle.setAttribute('aria-expanded', 'false');
    lockBody(false);
    window.setTimeout(function () {
      if (!parts.drawer.classList.contains('is-open')) {
        parts.drawer.hidden = true;
      }
    }, 220);
  }

  function parseSectionHtml(html) {
    var template = document.createElement('template');
    template.innerHTML = html ? html.trim() : '';
    return template.content.querySelector('[data-dodo-header]');
  }

  function syncCartToggle(currentRoot, newRoot) {
    var currentToggle = currentRoot.querySelector('[data-dodo-cart-toggle]');
    var newToggle = newRoot.querySelector('[data-dodo-cart-toggle]');
    var currentCount = currentToggle ? currentToggle.querySelector('sup') : null;
    var newCount = newToggle ? newToggle.querySelector('sup') : null;

    if (!currentToggle) {
      return;
    }

    if (newCount && !currentCount) {
      currentToggle.appendChild(newCount.cloneNode(true));
      return;
    }

    if (!newCount && currentCount) {
      currentCount.remove();
      return;
    }

    if (newCount && currentCount) {
      currentCount.textContent = newCount.textContent;
    }
  }

  function syncText(currentParent, newParent, selector) {
    var currentNode = currentParent ? currentParent.querySelector(selector) : null;
    var newNode = newParent ? newParent.querySelector(selector) : null;
    if (currentNode && newNode) {
      currentNode.textContent = newNode.textContent;
    }
  }

  function syncHtml(currentParent, newParent, selector) {
    var currentNode = currentParent ? currentParent.querySelector(selector) : null;
    var newNode = newParent ? newParent.querySelector(selector) : null;

    if (currentNode && newNode) {
      currentNode.innerHTML = newNode.innerHTML;
      return;
    }

    if (!currentNode && newNode && currentParent) {
      currentParent.appendChild(newNode.cloneNode(true));
      return;
    }

    if (currentNode && !newNode) {
      currentNode.remove();
    }
  }

  function syncReward(currentDrawer, newDrawer) {
    var currentReward = currentDrawer ? currentDrawer.querySelector('.dodo-cart-drawer__reward') : null;
    var newReward = newDrawer ? newDrawer.querySelector('.dodo-cart-drawer__reward') : null;

    if (!currentReward || !newReward) {
      return false;
    }

    var currentMessage = currentReward.querySelector('.progress_offer_wrap p');
    var newMessage = newReward.querySelector('.progress_offer_wrap p');
    var currentProgress = currentReward.querySelector('.progress');
    var newProgress = newReward.querySelector('.progress');

    if (currentMessage && newMessage) {
      currentMessage.innerHTML = newMessage.innerHTML;
    }

    if (currentProgress && newProgress) {
      currentProgress.style.width = newProgress.style.width;
    }

    ['.circle.c1', '.circle.c2', '.circle.c3'].forEach(function (selector) {
      var currentCircle = currentReward.querySelector(selector);
      var newCircle = newReward.querySelector(selector);

      if (currentCircle && newCircle) {
        currentCircle.innerHTML = newCircle.innerHTML;
      }
    });

    return true;
  }

  function syncCartDrawer(currentRoot, newRoot, openMode) {
    var currentParts = getDrawerParts(currentRoot);
    var newParts = getDrawerParts(newRoot);
    if (!currentParts.drawer || !newParts.drawer) {
      return;
    }

    var currentPanel = currentParts.drawer.querySelector('.dodo-cart-drawer__panel');
    var newPanel = newParts.drawer.querySelector('.dodo-cart-drawer__panel');
    var currentContent = currentParts.drawer.querySelector('.dodo-cart-drawer__content');
    var newContent = newParts.drawer.querySelector('.dodo-cart-drawer__content');
    var currentEmpty = currentParts.drawer.querySelector('.dodo-cart-drawer__empty');
    var newEmpty = newParts.drawer.querySelector('.dodo-cart-drawer__empty');

    if (!currentPanel || !newPanel) {
      currentParts.drawer.innerHTML = newParts.drawer.innerHTML;
    } else if (!currentContent || !newContent || currentEmpty || newEmpty) {
      currentPanel.innerHTML = newPanel.innerHTML;
    } else {
      syncText(currentPanel, newPanel, '.dodo-cart-drawer__count');
      syncReward(currentParts.drawer, newParts.drawer);
      syncHtml(currentContent, newContent, '.dodo-cart-drawer__items');
      syncHtml(currentContent, newContent, '.dodo-cart-drawer__freebie');
      syncHtml(currentContent, newContent, '.dodo-cart-drawer__upsell');
      syncHtml(currentPanel, newPanel, '.dodo-cart-drawer__footer');
    }

    if (openMode === 'instant-open') {
      setOpenState(currentRoot, true, true);
      return;
    }

    if (openMode) {
      setOpenState(currentRoot, true, false);
      return;
    }

    if (!currentParts.drawer.classList.contains('is-open')) {
      currentParts.drawer.hidden = true;
      currentParts.toggle.setAttribute('aria-expanded', 'false');
    }
  }

  function replaceHeaderSection(sectionHtml, openMode) {
    var currentRoot = getRoot();
    var newRoot = parseSectionHtml(sectionHtml);
    if (!currentRoot || !newRoot) {
      return;
    }

    syncCartToggle(currentRoot, newRoot);
    syncCartDrawer(currentRoot, newRoot, openMode);
  }

  function updateCartUiFromResponse(response, openMode) {
    var root = getRoot();
    var sectionId = getSectionId(root);
    if (!root || !sectionId) {
      return Promise.resolve();
    }

    if (response && response.sections && response.sections[sectionId]) {
      replaceHeaderSection(response.sections[sectionId], openMode);
      return Promise.resolve();
    }

    return window
      .fetch(window.location.pathname + '?section_id=' + encodeURIComponent(sectionId), {
        headers: { Accept: 'text/html' }
      })
      .then(function (res) {
        if (!res.ok) {
          throw new Error('Failed to refresh header section');
        }
        return res.text();
      })
      .then(function (html) {
        replaceHeaderSection(html, openMode);
      });
  }

  function cartRequest(url, payload) {
    var root = getRoot();
    var sectionId = getSectionId(root);
    var body = Object.assign({}, payload, {
      sections: sectionId,
      sections_url: window.location.pathname
    });

    return window.fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (errorData) {
          var message = errorData && (errorData.description || errorData.message);
          throw new Error(message || 'Cart request failed');
        });
      }

      return response.json();
    });
  }

  function addCartItem(payload) {
    return cartRequest('/cart/add.js', payload);
  }

  function updateCartItem(key, quantity) {
    return cartRequest('/cart/change.js', {
      id: key,
      quantity: quantity
    });
  }

  function bindGlobalAddToCart() {
    if (document.documentElement.dataset.dodoCartSubmitBound === 'true') {
      return;
    }

    document.documentElement.dataset.dodoCartSubmitBound = 'true';

    document.addEventListener('click', function (event) {
      var addButton = event.target.closest('[data-dodo-cart-add]');
      if (!addButton) return;

      // Skip if the button is inside the cart drawer (it has its own handler there)
      var root = getRoot();
      if (root && root.contains(addButton)) return;

      event.preventDefault();
      if (addButton.disabled) return;

      var variantId = Number(addButton.getAttribute('data-variant-id'));
      if (!variantId) return;

      addButton.disabled = true;
      var originalText = addButton.textContent;
      addButton.textContent = 'Adding…';

      addCartItem({ id: variantId, quantity: 1 })
        .then(function (response) {
          return updateCartUiFromResponse(response, false);
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          addButton.disabled = false;
          addButton.textContent = originalText;
        });
    });

    document.addEventListener('submit', function (event) {
      var form = event.target;
      var root = getRoot();
      var parts = getDrawerParts(root);

      if (!form || !root || !parts.drawer || !parts.toggle) {
        return;
      }

      if (!form.matches('form[action*="/cart/add"]')) {
        return;
      }

      if (event.submitter && event.submitter.closest('.shopify-payment-button')) {
        return;
      }

      event.preventDefault();

      var formData = new window.FormData(form);
      var id = formData.get('id');
      if (!id) {
        return;
      }

      var quantity = parseInt(formData.get('quantity') || '1', 10);
      if (!quantity || quantity < 1) {
        quantity = 1;
      }

      var submitter = event.submitter || form.querySelector('[type="submit"]');
      if (submitter) {
        submitter.disabled = true;
      }

      addCartItem({
        id: Number(id),
        quantity: quantity
      })
        .then(function (response) {
          return updateCartUiFromResponse(response, true);
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(function () {
          if (submitter) {
            submitter.disabled = false;
          }
        });
    });
  }

  function bindGlobalEscape() {
    if (document.documentElement.dataset.dodoCartEscapeBound === 'true') {
      return;
    }

    document.documentElement.dataset.dodoCartEscapeBound = 'true';

    document.addEventListener('keydown', function (event) {
      var root = getRoot();
      var parts = getDrawerParts(root);
      if (!parts.drawer) {
        return;
      }

      if (event.key === 'Escape' && parts.drawer.classList.contains('is-open')) {
        setOpenState(root, false);
      }
    });
  }

  function initCartDrawer(root) {
    if (!root || root.dataset.bound === 'true') {
      return;
    }

    var parts = getDrawerParts(root);
    if (!parts.drawer || !parts.toggle) {
      return;
    }

    root.dataset.bound = 'true';
    bindGlobalAddToCart();
    bindGlobalEscape();

    parts.toggle.addEventListener('click', function () {
      setOpenState(root, !parts.drawer.classList.contains('is-open'));
    });

    parts.drawer.addEventListener('click', function (event) {
      if (event.target === parts.drawer || event.target.closest('[data-dodo-cart-close]')) {
        setOpenState(root, false);
        return;
      }

      var changeButton = event.target.closest('[data-dodo-cart-change]');
      if (changeButton) {
        event.preventDefault();
        if (changeButton.disabled) {
          return;
        }

        changeButton.disabled = true;
        updateCartItem(
          changeButton.getAttribute('data-line-item-key'),
          Number(changeButton.getAttribute('data-quantity'))
        )
          .then(function (response) {
            return updateCartUiFromResponse(response, 'instant-open');
          })
          .catch(function (error) {
            console.error(error);
            changeButton.disabled = false;
          });
        return;
      }

      var addButton = event.target.closest('[data-dodo-cart-add]');
      if (addButton) {
        event.preventDefault();
        if (addButton.disabled) {
          return;
        }

        addButton.disabled = true;
        addCartItem({
          id: Number(addButton.getAttribute('data-variant-id')),
          quantity: 1
        })
          .then(function (response) {
            return updateCartUiFromResponse(response, 'instant-open');
          })
          .catch(function (error) {
            console.error(error);
            addButton.disabled = false;
          });
      }
    });
  }

  function mountAll() {
    var root = getRoot();
    if (root) {
      initCartDrawer(root);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll, { once: true });
  } else {
    mountAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) {
      return;
    }

    var root = event.target.matches && event.target.matches('[data-dodo-header]')
      ? event.target
      : event.target.querySelector('[data-dodo-header]');

    if (root) {
      initCartDrawer(root);
    }
  });
})();
